module.exports = __webpack_public_path__ + "static/media/hourCount.5ff4d7cb.png";